/*
* res-form config
* */
import 'js-datepicker/datepicker.css'
import './res-form-styles.css'

import '../../../css/_forms.css'

const dateConfig = {
    position: 'tr', // Top right.
    startDate: new Date(), // This month.
    startDay: 1, // Calendar week starts on a Monday.
    dateSelected: new Date(), // Today is selected.
    disabledDates: [new Date('1/1/2050'), new Date('1/3/2050')], // Disabled dates.
    minDate: new Date(2016, 5, 1), // June 1st, 2016.
    maxDate: new Date(2099, 0, 1), // Jan 1st, 2099.
    formatter: function(el, date, instance) {
    var day = date.getDate();
    var monthIndex = date.getMonth() +1;
    var year = date.getFullYear();

    el.value = day + '/' + monthIndex + '/' +year;
    },
    onSelect: function(instance) {
        // Show which date was selected.
        console.log(instance.dateSelected);
    },
    onShow: function(instance) {
        console.log('Calendar showing.');
    },
    onHide: function(instance) {
        console.log('Calendar hidden.');
    },
    onMonthChange: function(instance) {
        // Show the month of the selected date.
        console.log(instance.currentMonthName);
    },
    customMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        customDays: ['S', 'M', 'T', 'W', 'Th', 'F', 'S'],
    overlayPlaceholder: 'Enter a 4-digit year',
    overlayButton: 'Go!',
    disableMobile: true // Conditionally disabled on mobile devices.
}

const pickers = document.querySelectorAll('.datepicker')

let picker
for (picker of pickers) {
    datepicker(picker, dateConfig);
}